import type { ReactNode } from "react"

import * as styles from "./TextOveflow.module.css"

interface TextOverflowProps {
  children?: ReactNode
}

/**
 * A container showing an ellipsis when its children take more width than its constrained width.
 * If you need a gap between the children, use sx on each child.
 */
export function TextOverflow(props: TextOverflowProps) {
  const { children } = props

  return <span className={styles.textOverflow}>{children}</span>
}
